//NG+
import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AppSettings } from '../../app-settings';
import {  geocodingLocation, authAs, authOpt, authType, featureType, ILocationBData, ILocationSearchInfo, geosearchLocation } from '../../definitions';
import { MapController } from '../map-controller';
import { NGXLogger } from 'ngx-logger';
import { getExMessage } from '../map-utils';

import VectorLayer from 'ol/layer/Vector';
import * as olExtent from 'ol/extent';
import VectorSource from "ol/source/Vector";
import GeoJSONFormater from "ol/format/GeoJSON";
import WKTFormater from "ol/format/WKT";
import OlStyle from "ol/style/Style";
import StrokeStyle from "ol/style/Stroke";
import FillStyle from "ol/style/Fill";
import * as olColor from 'ol/color';
import * as olProj from 'ol/proj';

@Component({
    selector: 'map-location-search-custom-b',
    providers: [],
    templateUrl: './map-location-search-custom-b.component.html',
    styleUrls: ['./map-location-search-custom-b.component.css']
})
export class MapLocationSearchCustomBComponent implements OnInit, OnChanges {

    @Input("mapctrl") mapCtrl: MapController = null;
    //
    public infoPositionSearch = $localize`\:Introduceți adresa sau coordonate geografice in format wgs84 (exemplu 46.76453, 23.57964).`;
    private polyStyle = new OlStyle({
        fill: new FillStyle({
            color: olColor.asArray('rgba(0,0,230,0.3)')
        }),
        stroke: new StrokeStyle({
            color: 'rgba(0,0,255,1)',
            width: 2
        })
    });
    private lineStyle =  new OlStyle({
        stroke: new StrokeStyle({
            width: 10, color: [237, 112, 0, 0.6]
        })
    });
    //
    public locationBData: ILocationBData;
    public constructor(
        @Inject(NGXLogger) private $log: NGXLogger,){

    }
    public ngOnInit(): void {
        //
        this.locationBData = this.mapCtrl.locationBData;
        this.mapCtrl.locationBData.funcInit = this.initLocationBTool;
        this.mapCtrl.locationBData.funcClear = this.clearLocationBTool;
    }

    public ngOnChanges(changes: SimpleChanges) {
        //
    }


    //
    //Position marker for center and geoposition
    //
    
    public initLocationBTool = () => {
        this.mapCtrl.setMenuCollapsed();
        this.locationBData.disableSearch = false;
        if (this.locationBData.selectedOption == 'search') {
            this.locationBData.strada = '';
            this.locationBData.numar = '';
        } else {
            this.locationBData.long = '';
            this.locationBData.lat = '';
        }
        this.addLocationLayer();
        this.addNetworkLayer();
    }

    public clearLocationBTool = () => {
        this.mapCtrl.locationBButtonStateOn = false;
        this.locationBData.strada = '';
        this.locationBData.numar = '';
        this.locationBData.long = '';
        this.locationBData.lat = '';
        this.locationBData.disableSearch = false;
        this.locationBData.locations.length = 0;
        this.locationBData.selectedLocation = null;
        this.locationBData.locationLayer.getSource().clear();
        this.locationBData.showLocationList = false;
        this.locationBData.showLocationInfo = false;
        this.locationBData.activeSearchLocations = false;

        if (this.mapCtrl.positionMarkerOverlay) {
            this.mapCtrl.map.removeOverlay(this.mapCtrl.positionMarkerOverlay);
        }
        this.removeLocationLayer();
        this.removeNetworkLayer();
    }

    public onClickPositionClose() {
        this.clearLocationBTool();
    }

    public onChangePositionOption(option: string) {
        this.positionByGeocodingOrLocation(option == 'search' ? true : false);
    }

    positionByGeocodingOrLocation(enable: boolean) {
        //todo
        if (enable) {
            this.locationBData.disableSearch = false;

        } else {
            this.locationBData.disableSearch = false;
            this.locationBData.locations.length = 0;
            this.locationBData.searchText = '';
        }
    }

    onSearchPositionByGeocoding() {
        this.locationBData.locations.length = 0;
        this.locationBData.locationLayer.getSource().clear();
        this.locationBData.networkLayer.getSource().clear();
        this.locationBData.showLocationList = true;
        this.locationBData.showLocationInfo = false;
        this.locationBData.selectedLocation = null;
        //
        if (this.locationBData.selectedOption == 'search'){
            if (this.locationBData.localitate.length == 0){
            this.$log.error("strada localitate");
            return;
            }
            if (this.locationBData.numar.length == 0 && this.locationBData.strada.length == 0){     
                this.$log.error("strada si numar lipseste");
                return;
            }
        } else {
            if (this.locationBData.lat.length == 0){
                this.$log.error("latitudine lipseste");
                return;
            }
            if (this.locationBData.long.length == 0){
                this.$log.error("longitudine lipseste");
                return;
            }
        }
        //
        this.locationBData.disableSearch = true;
        this.locationBData.activeSearchLocations = true;
        let tmpSearchInfo: ILocationSearchInfo = {
            tip: this.locationBData.selectedOption,
            localitate: this.locationBData.localitate,
            strada: this.locationBData.strada,
            numar: this.locationBData.numar,
            lat: this.locationBData.lat,
            long: this.locationBData.long,

        }
        this.mapCtrl.userSettingsSrvs.getLocationBByGeosearch(tmpSearchInfo)
            .then((data) => {
                this.locationBData.locations = data;
                let gjson = new GeoJSONFormater();
                //geom features
                this.locationBData.locations.forEach((litem) => {
                    try {
                        if (litem.geojson) {//gjson.readFeature
                            let feature = gjson.readFeature(litem.geojson, { dataProjection: "EPSG:31700", featureProjection: this.mapCtrl.mapConfig.projection });
                            if (feature) {
                                litem.feature = feature;
                                if (feature.getGeometry().getType() === 'Polygon' as any) {
                                    feature.setStyle(this.polyStyle)
                                }
                            }
                        }
                    } catch (reason) {
                        this.$log.error("Eroare creare locatie ", getExMessage(reason));
                    }
                })

            }).catch((reason) => {
                this.$log.error("eroare la interogare geolocatie ", getExMessage(reason));

            }).finally(() => {
                this.locationBData.disableSearch = false;
                this.locationBData.activeSearchLocations = false;
            })
    }

    onClickPositionResults(item: geosearchLocation) {
        try {
            this.locationBData.disableSearch = true;
            this.locationBData.activeSearchLocations = true;
            //
            this.locationBData.locationResultInfo = [];
            this.locationBData.showLocationInfo = false;
            this.locationBData.selectedLocation = item;
            
            //selectie locatie
            //let reorderextent = [Number(item.boundingbox[2]), Number(item.boundingbox[0]), Number(item.boundingbox[3]), Number(item.boundingbox[1])]
            //let extentAtProj = olProj.transformExtent(reorderextent as olExtent.Extent, "EPSG:4326", this.mapCtrl.map.getView().getProjection());
            let extentAtProj = item.feature.getGeometry().getExtent();
            this.mapCtrl.map.getView().fit(extentAtProj,{padding:[200,50,50,50]});
            this.locationBData.networkLayer.getSource().clear();
            this.locationBData.locationLayer.getSource().clear();
            if (item.feature) {
                this.locationBData.locationLayer.getSource().addFeature(item.feature);
            }
            // Extract WKT from feature geometry, transforming to EPSG:4326
            let geometry = item.feature.getGeometry();
            let geometryWgs84 = geometry.clone().transform(this.mapCtrl.mapConfig.projection, 'EPSG:4326');
            let wktFormater = new WKTFormater();
            let wktGeom = wktFormater.writeGeometry(geometryWgs84);

            //
            //info locatie custom
            this.mapCtrl.userSettingsSrvs.getLocationBCustomInfo(wktGeom)
            .then((data) => {
                this.locationBData.locationResultInfo = data;
            }).catch((reason) => {
                this.$log.error("eroare la interogare informatii conexe locatie ", getExMessage(reason));

            }).finally(() => {
                this.locationBData.disableSearch = false;
                this.locationBData.activeSearchLocations = false;
            })
            //
        } catch (reason) {
            this.$log.error("eroare pozitionare pe locatie", getExMessage(reason));
        }
    }
    //
    onClickNetowrkInfo(network) {
        try {
            let gjson = new GeoJSONFormater();
            this.locationBData.networkLayer.getSource().clear();
            let feature = gjson.readFeature(network.geom, { dataProjection: "EPSG:31700", featureProjection: this.mapCtrl.mapConfig.projection });
            if (feature) {
                if (feature.getGeometry().getType() === 'LineString' as any) {
                    feature.setStyle(this.lineStyle)
                }
                this.locationBData.networkLayer.getSource().addFeature(feature);
            }
        } catch (error) {
            this.$log.error("eroare afisare retea conexa");
        }
    }
    //
    onClickPositionShowInfo(location){
        this.locationBData.showLocationInfo = true;
        this.locationBData.showLocationList = false;

    }
    //
    onClickPositionHideInfo(location){
        this.locationBData.showLocationInfo = false;
        this.locationBData.showLocationList = true;
        this.locationBData.networkLayer.getSource().clear();
    }
    //


   
    isVisibleLocation(locatie: geocodingLocation) {
        if (this.locationBData.numaiUnitatiTeritoriale === false) {
            return true;
        }
        if (this.locationBData.numaiUnitatiTeritoriale === true
            && locatie.feature.getGeometry().getType() === 'Polygon'
            && (locatie.type === "administrative"
                || locatie.type === "village")) {
            return true;
        }
        return false;
    }
    public addLocationLayer() {
        this.locationBData.locationLayer = new VectorLayer<any>({
            source: new VectorSource({ wrapX: false })
        });
        this.mapCtrl.map.addLayer(this.locationBData.locationLayer);
        this.locationBData.locationLayer.setZIndex(100000);
    }
    //
    public removeLocationLayer() {
        if (this.locationBData.locationLayer) {
            this.mapCtrl.map.removeLayer(this.locationBData.locationLayer);
            this.locationBData.locationLayer = null;
        }
    }
    public addNetworkLayer() {
        this.locationBData.networkLayer = new VectorLayer<any>({
            source: new VectorSource({ wrapX: false })
        });
        this.locationBData.networkLayer.setZIndex(100001);
        this.mapCtrl.map.addLayer(this.locationBData.networkLayer);
    }
    //
    public removeNetworkLayer() {
        if (this.locationBData.networkLayer) {
            this.mapCtrl.map.removeLayer(this.locationBData.networkLayer);
            this.locationBData.networkLayer = null;
        }
    }

}
